import api from './api';

// Список пользователей (без хешей паролей — сервер их не отдаёт).
export const getUsers = async () => {
  const response = await api.get('/api/auth/users');
  return response.data.users;
};

// Создание нового пользователя.
export const createUser = async ({ username, password, role }) => {
  const response = await api.post('/api/auth/register', { username, password, role });
  return response.data;
};

// Смена пароля пользователя по id.
// Администратор не указывает currentPassword; обычный пользователь обязан.
export const changePassword = async (id, { newPassword, currentPassword }) => {
  const response = await api.put(`/api/auth/users/${id}/password`, { newPassword, currentPassword });
  return response.data;
};

// Смена роли пользователя по id (только администратор).
export const changeRole = async (id, role) => {
  const response = await api.put(`/api/auth/users/${id}/role`, { role });
  return response.data;
};

// Удаление пользователя по id (только администратор).
export const deleteUser = async (id) => {
  const response = await api.delete(`/api/auth/users/${id}`);
  return response.data;
};
